import React, { StrictMode, useEffect } from 'react';

import { ContextProvider as UsersContextProvider } from 'components/Users/Context';

import routes from 'app/routes';

import useChats from 'components/Common/Chats/Hooks/useChats';

import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Main from './Main';
import Messages from './Messages';

export default function Index() {
  const { chats, updateCountUnreadMessage } = useChats();

  useEffect(() => {
    if (chats) {
      const counter = document.querySelector('#menu .unread-messages');

      if (counter) {
        const unreadMessages = chats.map((chat) => chat.attributes.unread).reduce((acc, val) => acc + val, 0);

        counter.innerHTML = unreadMessages > 0 ? `<span>${unreadMessages}</span>` : '';
      }
    }
  }, [chats]);

  const router = createBrowserRouter([
    {
      path: routes.members.chats.index,
      element: <Main chats={chats} />,
      children: [
        {
          path: routes.members.chats.messages(),
          element: <Messages updateCountUnreadMessage={updateCountUnreadMessage} />,
        },
      ],
    },
  ]);

  return (
    <StrictMode>
      <UsersContextProvider>
        <RouterProvider router={router} />
      </UsersContextProvider>
    </StrictMode>
  );
}
